import React, { useEffect, useState, useRef } from "react";
import { Row, Col } from "react-bootstrap";
import Backdrop from "@material-ui/core/Backdrop";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import styles from "./ControlSet.module.css";
import ToggleBtn from "../../../ReusableComponents/ToggleBtn/ToggleBtn";
import DownArrow from "../../../Icons/DownArrow";
import { useMediaQuery } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import cloneDeep from "lodash-es/cloneDeep";
import CustomizedAlert from "../../../ReusableComponents/Alert/CustomizedAlert";
import { GetStateFromData } from "../../CustomHooks/CustomHooks";

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
  backdropBody: {
    alignItems: "start",
  },
  defnHeight: {
    maxHeight: "54vh",
  },
  defnHeight2: {
    maxHeight: "52vh",
  },
}));

export default function ControlSet(props) {
  const { t } = useTranslation(["styles", "translation"]);
  const matches = useMediaQuery("(min-width: 1181px)");
  const classes = useStyles();
  const { open, onClose } = props;
  const [alertData, setAlertData] = useState(false)
  const [isEditable, setIsEditable] = useState(false)
  const contexts = GetStateFromData(props.containerId);
  const gridContexts = GetStateFromData(props.containerId,"data2");

  const {
    advanceListviewStateJson,
  } = gridContexts.gridStates;

  const {
    updateJson,
    formState2,
    openCanvasForSubform,
    subFormStateJson,
    containerId,
  } = contexts.contexts;

  const { updatedComponentInFormState } = updateJson;

  let controlSetState = [];
  if (
    openCanvasForSubform === "advanceListviewFromScratch" &&
    advanceListviewStateJson !== undefined &&
    advanceListviewStateJson.controlSet &&
    advanceListviewStateJson.controlSet.length > 0
  ) {
    controlSetState = advanceListviewStateJson.controlSet;
  } else if (
    openCanvasForSubform === "subform" &&
    subFormStateJson !== undefined &&
    subFormStateJson.controlSet &&
    subFormStateJson.controlSet.length > 0
  ) {
    controlSetState = subFormStateJson.controlSet;
  } else if (
    formState2 &&
    formState2.controlSet &&
    formState2.controlSet.length > 0 &&
    openCanvasForSubform !== "advanceListviewFromScratch" &&
    openCanvasForSubform !== "subform"
  ) {
    controlSetState = formState2.controlSet;
  }

  const [controlSetDetails, setcontrolSetDetails] = React.useState(
    cloneDeep(controlSetState)
  );
  const [copyControlSetDetails, setCopyControlSetDetails] =
    React.useState(controlSetState);
  const [selectedControlSetIndex, setSelectedControlSetIndex] =
    React.useState(0);
  const [filteredControlSetName, setFilteredControlSetName] = React.useState({
    controlSetName: "",
    controlId: "",
    treeControlId: "",
  });
  const [checksIds, setCheckIds] = React.useState(new Set());
  const [checkDetails, setCheckDetails] = React.useState(false);
  const [tempState, setTempState] = useState(0);
  var controlSetJson1 = {};
  const [controlSetJson, setControlSetJson] = useState({})

  let controlSetDataJson = useRef(controlSetJson)

  function agentHas(keyword) {
    return (
      window.navigator.userAgent.toLowerCase().search(keyword.toLowerCase()) >
      -1
    );
  }

  let isSafariBrowser = function isSafari() {
    return (
      (!!window.ApplePaySetupFeature || !!window.safari) &&
      agentHas("Safari") &&
      !agentHas("Chrome") &&
      !agentHas("CriOS")
    );
  };

  useEffect(() => {
  if (formState2 !== undefined) {
    var allFormIds = new Set();
    if (
      openCanvasForSubform === "advanceListviewFromScratch" &&
      advanceListviewStateJson !== undefined
    ) {
      readFormData(
        advanceListviewStateJson?.children,
        controlSetJson,
        controlSetJson1,
        allFormIds
      );
    } else if (
      openCanvasForSubform === "subform" &&
      subFormStateJson !== undefined
    ) {
      readFormData(
        subFormStateJson?.children,
        controlSetJson,
        controlSetJson1,
        allFormIds
      );
    } else {
      readFormData(
        formState2?.children,
        controlSetJson,
        controlSetJson1,
        allFormIds
      );
    }
  }
}, [])

useEffect(() => {
  if(controlSetDetails && controlSetDetails[selectedControlSetIndex]){
    let result = handleUncheckAll(controlSetJson["RootControl"])
    setControlSetJson({"RootControl": result})
    Object.keys(controlSetDetails[selectedControlSetIndex]).forEach((key, idx) => {
      if(controlSetDetails[selectedControlSetIndex][key]?.id){
      let result = handleCheckData(controlSetJson["RootControl"], controlSetDetails[selectedControlSetIndex][key]?.id)
      setControlSetJson({"RootControl": result})
    }
    })
  }
  }, [selectedControlSetIndex])

  useEffect(() => {
    var allFormIds = new Set();
  }, [checkDetails]);

  function handleCancel() {
    setcontrolSetDetails(copyControlSetDetails);
    onClose();
  }

  const [isValid, setIsValid] = useState(true);
  const [isBlank, setIsBlank] = useState(false);

  function handleSave() {
    if (
      openCanvasForSubform === "advanceListviewFromScratch" &&
      advanceListviewStateJson !== undefined
    ) {
      advanceListviewStateJson.controlSet = controlSetDetails;
    } else if (
      openCanvasForSubform === "subform" &&
      subFormStateJson !== undefined
    ) {
      subFormStateJson.controlSet = controlSetDetails;
    } else {
      formState2.controlSet = controlSetDetails;
    }

    setCopyControlSetDetails(controlSetDetails);
    updatedComponentInFormState();
    if (isValid === true && isBlank == false) {
      setAlertData({
        'open':true,
        "alertContentMsg": `${t("translation:The control set has been saved successfully.")}`,
        'showConfirm':'showNotification',
        'alertType':'success',
        "autoHideDuration": 4000,
    })
      onClose();
    } else if (isBlank == true) {
      setAlertData({
        'open':true,
        "alertContentMsg":  `${t("translation:The Control Set name cannot be blank. Please provide a name for Control Set.")}`,
        'showConfirm':'showNotification',
        'alertType':'error',
        "autoHideDuration": 3000,
    })
    } else {
      setAlertData({
        'open':true,
        "alertContentMsg":  `${t("translation:A Control Set with this name already exists. Please choose a different name.")}`,
        'showConfirm':'showNotification',
        'alertType':'error',
        "autoHideDuration": 3000,
    })
    }
  }

  function handleEdit() {
    setIsEditable(true)
  }

  function filterSearchedItem(action, searchedText) {
    if (action === "controlSetName") {
      setFilteredControlSetName((prev) => {
        return { ...prev, controlSetName: searchedText };
      });
    } else if (action === "controlId") {
      setFilteredControlSetName((prev) => {
        return { ...prev, controlId: searchedText };
      });
    } else if (action === "treeControlId") {
      setFilteredControlSetName((prev) => {
        return { ...prev, treeControlId: searchedText };
      });
    } else if (action === "controlName") {
      if (searchedText === "horizontal") {
      }
    }
  }

  function handleControlSetDetails(e, action, controlDetails, controlSetJson) {
    setIsChange(true)    
    if (action === "addDelete") {
      var flag = 0;
      if (
        controlSetJson[controlDetails?.id] !== undefined &&
        controlSetJson[controlDetails?.id]?.children !== undefined
      ) {
        let res = IsChildChecked(controlSetJson[controlDetails?.id])
        if(res){
          flag = 1
        }
      }

      if (flag === 0) {
        if (e.target.type === "checkbox") setModifyBtn(true);

        if(controlSetDetails.length > 0){
        let result = handleCheckData(controlSetDataJson.current["RootControl"], controlDetails?.id)
        setControlSetJson({"RootControl": result})
        }

        setcontrolSetDetails(
          controlSetDetails.map((controlSet, setIndex) => {
            if (setIndex === selectedControlSetIndex) {
              if (controlSet[controlDetails.id]) {
                if(controlDetails?.isChecked === false){
                delete controlSet[controlDetails.id];
              }
                return { ...controlSet };
              } else {
                if(controlDetails.isChecked){
                return { ...controlSet, [controlDetails.id]: JSON.parse(JSON.stringify(controlDetails)) };
              }
              }
            }
            return controlSet;
          })
        );
      } else if (flag === 1) {
        setAlertData({
          'open':true,
          "alertContentMsg": `${t("translation:This control cannot be selected because its child controls are already selected. Please deselect the child controls first.")}`,
          'showConfirm':'showNotification',
          'alertType':'error',
          "autoHideDuration": 3000,
      })
        e.preventDefault();
      }
    } else if (action === "Creatwqe") {
    }
  }
  const translationStyles = {
    left: t("styles:searchIconLeft"),
    right: t("styles:searchIconRight"),
  };
  const translationStyles1 =
    window?.psh_configs?.selectedLanguage === "ar" || window?.psh_configs?.selectedLanguage === "ar-SA";
  const [err, setErr] = useState("old value");

  //added modify btn
  const [modifybtn, setModifyBtn] = useState(false);
  var samenamevar = false;
  const [countSet, setCountSet] = useState(1);
  const [isChange,setIsChange] = useState(false);

  function handleControlSet(event, action, index, controlId) {
    event.preventDefault()
    if (action !== "selectedControlSet"){
      setModifyBtn(true);
      setIsChange(true);
    }

    if (action === "create") {
      setAlertData({
        'open':true,
        "alertContentMsg":  `${t("translation:Control Set Created Successfully")}`,
        'showConfirm':'showNotification',
        'alertType':'success',
        "autoHideDuration": 3000,
    })

      let max_value = 0

      controlSetDetails?.map((controls) => {
          // let res = controls?.label?.slice(-2)
          let resArr = controls?.label?.split(" ")
          let res = resArr[resArr.length - 1]
          if(Number(res) > max_value){
              max_value = Number(res)
          }
      })

      setCountSet((prev) => prev + 1);
      setcontrolSetDetails((prev) => [
        ...prev,
        { label: `${t("translation:Control Set ")}` + "" + (max_value + 1) },
      ]);

      setSelectedControlSetIndex(controlSetDetails.length);
      setIsEditable(true)
    } else if(action === "duplicate"){
      let currentControlSet = JSON.parse(JSON.stringify(controlSetDetails[selectedControlSetIndex]))
      let currentCSlabel = currentControlSet?.label.split('-')[0]
      const isControlSetPresent = controlSetDetails.filter((controlSet) => controlSet?.label?.split('-')[0] === currentCSlabel)
      const selectedControlSet = controlSetDetails[index]?.label
      const selectedControlSetLen = selectedControlSet?.split('-')?.length

      let max_duplicate_value = 0

      isControlSetPresent?.map((controls) => {
          let res = controls?.label?.split("-")[selectedControlSetLen]
          if(Number(res?.slice(1, -1)) > max_duplicate_value){
              max_duplicate_value = Number(res?.slice(1, -1))
          }
      })
      setcontrolSetDetails((prev) => [
        ...prev,
        {...currentControlSet, label: `${currentControlSet?.label}-(${max_duplicate_value + 1})`}
      ])
    } else if (action === "selectedControlSet") {
      setSelectedControlSetIndex(index);
      setIsBlank(false);
      if(!event.target.className.includes("selectedControlSet") && !isNaN(tempState)){
        setIsEditable(false)
        setIsChange(false)
      }
      setTempState(0)
    } else if (action === "changeLabel") {
      setTempState(index);
      samenamevar = false;
      for (let i = 0; i < controlSetDetails.length; i++) {
        if (controlSetDetails[i].label === index && controlSetDetails[i].label !== controlSetDetails[selectedControlSetIndex].label) {
          samenamevar = true;
          break;
        }
      }

      //add error for zero length

      if (index.length === 0) {
        setIsBlank(true);
        setAlertData({
          'open':true,
          "alertContentMsg": `${t("translation:The Control Set name cannot be blank. Please provide a name for Control Set.")}`,
          'showConfirm':'showNotification',
          'alertType':'error',
          "autoHideDuration": 3000,
      })
      } else if (samenamevar == false && index.length > 0) {
        setIsBlank(false);
        setIsValid(true);
        setErr("old value");
        setcontrolSetDetails(
          controlSetDetails.map((controlSet, setIndex) => {
            if (setIndex === selectedControlSetIndex)
              return { ...controlSet, label: index };
            return controlSet;
          })
        );
      } else {
        setIsBlank(false);
        setIsValid(false);
        setAlertData({
          'open':true,
          "alertContentMsg": `${t("translation:A Control Set with this name already exists. Please choose a different name.")}`,
          'showConfirm':'showNotification',
          'alertType':'error',
          "autoHideDuration": 3000,
      })
      }
      setErr(`${t("translation:Control Set with same name already present")}`);
    } else if (action === "delete") {
      event.stopPropagation()
      var controlSetBeforeDeletion = [...controlSetDetails];
      controlSetBeforeDeletion.splice(index, 1);
      setAlertData({
        'open':true,
        "alertContentMsg": t("translation:The control set has been deleted successfully."),
        'showConfirm':'showNotification',
        'alertType':'success',
        "autoHideDuration": 3000,
    })
      
      let result = handleUncheckAll(controlSetJson["RootControl"])
      setControlSetJson({"RootControl": result})

      setSelectedControlSetIndex(
        Math.min(selectedControlSetIndex, controlSetBeforeDeletion.length - 1)
      );
      setcontrolSetDetails(controlSetBeforeDeletion);
      setIsEditable(false)
      // setIsChange(false)
    } else if (
      index === "Visible" ||
      index === "Enable" ||
      index === "Mandatory"
    ) {
      if (
        controlSetDetails?.[selectedControlSetIndex]?.[controlId]
          ?.actionCheckboxChecked
      ) {
        const updatedControlSet = structuredClone(
          controlSetDetails[selectedControlSetIndex]
        );

        Object.values(updatedControlSet).forEach((control) => {
          if (control.actionCheckboxChecked) {
            if (index === "Visible")
              control.value =
                (action.target.value === "true" ? "1" : "0") +
                control.value.substring(1);
            else if (index === "Enable")
              control.value =
                control.value.substring(0, 1) +
                (action.target.value === "true" ? "1" : "0") +
                control.value.substring(2);
            else if (index === "Mandatory")
              control.value =
                control.value.substring(0, 2) +
                (action.target.value === "true" ? "1" : "0");
          }
        });
        const updatedControlSetDetails = structuredClone(controlSetDetails);
        updatedControlSetDetails[selectedControlSetIndex] = updatedControlSet;
        setcontrolSetDetails(updatedControlSetDetails);
      } else {
        setcontrolSetDetails(
          controlSetDetails.map((controlSet, setIndex) => {
            if (setIndex === selectedControlSetIndex) {
              if (controlSet[controlId]) {
                if (index === "Visible")
                  controlSet[controlId].value =
                    (action.target.value === "true" ? "1" : "0") +
                    controlSet[controlId].value.substring(1);
                else if (index === "Enable")
                  controlSet[controlId].value =
                    controlSet[controlId].value.substring(0, 1) +
                    (action.target.value === "true" ? "1" : "0") +
                    controlSet[controlId].value.substring(2);
                else if (index === "Mandatory")
                  controlSet[controlId].value =
                    controlSet[controlId].value.substring(0, 2) +
                    (action.target.value === "true" ? "1" : "0");
                return { ...controlSet };
              } else {
                return { ...controlSet };
              }
            }
            return controlSet;
          })
        );
      }
    } else if (action === "combo") {
      var select = document.getElementById(index);
      var optionTag = select.options[select.selectedIndex];
      setcontrolSetDetails(
        controlSetDetails.map((controlSet, setIndex) => {
          if (setIndex === selectedControlSetIndex) {
            if (controlSet[controlId]) {
              controlSet[controlId].defaultValue = optionTag.value;
              if (optionTag.value !== "Explicit") {
                delete controlSet[controlId]["ExplicitValue"];
              }
              return { ...controlSet };
            } else {
              return { ...controlSet };
            }
          }
          return controlSet;
        })
      );
    } else if (action === "explicitValue") {
      setcontrolSetDetails(
        controlSetDetails.map((controlSet, setIndex) => {
          if (setIndex === selectedControlSetIndex) {
            if (controlSet[controlId]) {
              controlSet[controlId].ExplicitValue = index;
              return { ...controlSet };
            } else {
              return { ...controlSet };
            }
          }
          return controlSet;
        })
      );
    } else if (action === "actionDelete") {
      var controlArray = [...controlSetDetails];
      if(Object.keys(controlArray[selectedControlSetIndex]).length > 0){
        let res = handleCheckData(controlSetDataJson.current["RootControl"], controlArray[selectedControlSetIndex][controlId]["id"])
        setControlSetJson({"RootControl": res})
      }
      delete controlArray[selectedControlSetIndex][controlId];
      setcontrolSetDetails(controlArray);
    }
  }

  controlSetDetails.sort((a, b) => a.label.localeCompare(b.label));

  useEffect(() => {
    for (let i = 0; i < controlSetDetails.length; i++) {
      if (controlSetDetails[i].label === tempState)
        document.querySelectorAll(".abc")[i]?.click();
      setModifyBtn(true);
    }
  }, [tempState]);

  useEffect(() => {
    setCopyControlSetDetails(
    controlSetDetails.map((controlSet) => {
      for(var control in controlSet){
        if(typeof controlSet[control] === 'object'){
        updateData(controlSetJson["RootControl"], controlSet[control])
        }
      }
      return{...controlSet}
    })
    )
  }, [selectedControlSetIndex])

  const istrue = () => {
    const cloneControlSet = structuredClone(
      controlSetDetails?.[selectedControlSetIndex]
    );
    delete cloneControlSet?.label;

    return Object.values(cloneControlSet).every(
      (item) => item?.actionCheckboxChecked
    );
  };
  useEffect(()=>{
    document.getElementById("backdropDiv")?.focus();
    
   },[])
  function handleEscapeKey(e) {
    if (e.code === "Escape") {
      handleCancel();
    }
  }

  const handlecheckBoxChange = (e, key) => {
    if (key === "allActionCheckboxClicked") {
      const updatedControlSet = structuredClone(
        controlSetDetails[selectedControlSetIndex]
      );

      Object.values(updatedControlSet).forEach((control) => {
        if (typeof control === "object") {
          const isEveryControlChecked = istrue();
          if (isEveryControlChecked) {
            control.actionCheckboxChecked = false;
          } else {
            control.actionCheckboxChecked = e.target.checked;
          }
        }
      });

      const updatedControlSetDetails = structuredClone(controlSetDetails);
      updatedControlSetDetails[selectedControlSetIndex] = updatedControlSet;

      setcontrolSetDetails(updatedControlSetDetails);
    } else {
      setcontrolSetDetails(
        controlSetDetails.map((controlSet, setIndex) => {
          if (setIndex === selectedControlSetIndex) {
            if (controlSet[key]) {
              controlSet[key].actionCheckboxChecked = e.target.checked;
            }
            return controlSet;
          }
          return controlSet;
        })
      );
    }
  };

  return (
    <div>
      <Backdrop className={classes.backdrop} open={open}>
        <div
          tabIndex="0"
          onKeyDown={(e) => handleEscapeKey(e)}
          className={styles.backdropDiv}
          id="backdropDiv"
        >
          <Row className={styles.backdropHeader}>
            {openCanvasForSubform === "subform"
              ? t("translation:Control Set - Navigation Subform (Button)")
              : t("translation:Control Set - Navigation Page")}
          </Row>

          <Row className={[styles.backdropBody, classes.backdropBody]}>
            <Col className={styles.backdropLeftBody}>
              <Col className={styles.controlSetAddCol}>
                {t("translation:Control Sets")}
                <img
                  src={require("../../../Icons/controlSetAdd.svg").default}
                  style={{ height: "100%", cursor: "pointer" }}
                  onClick={(ev) => handleControlSet(ev, "create")}
                  title={t("translation:Add Control Set")}
                  alt="Add Icon"
                />
              </Col>

              <Col className={styles.searchCol}>
                <input
                  type="text"
                  aria-label="Input Search"
                  placeholder={t("translation:Search")}
                  className={styles.searchInput}
                  onChange={
                    controlSetDetails.length > 0
                      ? (event) =>
                          filterSearchedItem(
                            "controlSetName",
                            event.target.value
                          )
                      : null
                  }
                />
                <img
                  src={require("../../../Icons/Search.svg").default}
                  className={styles.searchIcon}
                  style={translationStyles}
                  alt="Search Icon"
                />
              </Col>

              <div
                className={styles.controlSetNameColParent}
                style={
                  containerId === "mf_formBuilder"
                    ? { maxHeight: "59vh" }
                    : { maxHeight: "57vh" }
                }
              >
                {filteredControlSetName &&
                filteredControlSetName["controlSetName"].length === 0
                  ? controlSetDetails &&
                    controlSetDetails.map((controlSet, index) => {
                      return (
                        <div className={`controllistdetails`} 
                        onClick={(ev) =>
                          handleControlSet(ev, "selectedControlSet", index)
                        }>
                          <Col
                            className={[
                              "abc",
                              styles.controlSetNameCol,
                              selectedControlSetIndex === index
                                ? styles.selectedControlSet
                                : null,
                            ].join(" ")}
                           >
                            <span
                              className={styles.pageTitleText}
                              title={controlSet.label}
                            >
                              {controlSet.label}
                            </span>

                            {selectedControlSetIndex === index ? (
                              <span>
                                <img
                                  title={t("translation:Duplicate Control Set")}
                                  src={
                                    require("../../../Icons/DuplicateControlSet.svg")
                                      .default
                                  }
                                  className={styles.deleteEditIcon}
                                  onClick={(ev) =>
                                    handleControlSet(ev, "duplicate", index)
                                  }
                                  alt="Edit Icon"
                                />
                                <img
                                  title={t("translation:Delete Control Set")}
                                  src={
                                    require("../../../Icons/deleteRed.svg")
                                      .default
                                  }
                                  className={styles.deleteEditIcon}
                                  onClick={(ev) =>
                                    handleControlSet(ev, "delete", index)
                                  }
                                  alt="Edit Icon"
                                />
                              </span>
                            ) : (
                              <></>
                            )}
                          </Col>
                        </div>
                      );
                    })
                  : controlSetDetails &&
                    controlSetDetails.map((controlSet, index) => {
                      return controlSet.label &&
                        controlSet.label
                          .toLowerCase()
                          .includes(
                            filteredControlSetName[
                              "controlSetName"
                            ].toLocaleLowerCase()
                          ) ? (
                        <Col
                          className={[
                            styles.controlSetNameCol,
                            selectedControlSetIndex === index
                              ? styles.selectedControlSet
                              : null,
                          ].join(" ")}
                        >
                          <span
                            className={styles.pageTitleText}
                            onClick={(ev) =>
                              handleControlSet(ev, "selectedControlSet", index)
                            }
                          >
                            {controlSet.label}
                          </span>

                          {selectedControlSetIndex === index ? (
                            <span>
                              <img
                                src={
                                  require("../../../Icons/DuplicateControlSet.svg")
                                    .default
                                }
                                className={styles.deleteEditIcon}
                                onClick={(ev) =>
                                  handleControlSet(ev, "duplicate", index)
                                }
                                alt="Edit Icon"
                              />
                            <img
                                src={
                                  require("../../../Icons/deleteRed.svg")
                                    .default
                                }
                                className={styles.deleteEditIcon}
                                onClick={(ev) =>
                                  handleControlSet(ev, "delete", index)
                                }
                                alt="Delete Icon"
                              />
                            </span>
                          ) : (
                            <></>
                          )}
                        </Col>
                      ) : (
                        <></>
                      );
                    })}
              </div>
            </Col>

            <Col
              className={styles.backdropCenterBody}
              style={
                containerId === "mf_formBuilder"
                  ? { maxHeight: "71vh" }
                  : { maxHeight: "69vh" }
              }
            >
              <Col className={styles.controlSetAddCol}>
                {t("translation:Select Controls to add in control set")}
              </Col>
              <Col className={styles.searchCol + " " + styles.searchCol3}>
                <input
                  type="text"
                  aria-label="Input Search1"
                  placeholder={t("translation:Search")}
                  className={styles.searchInput}
                  onChange={
                    controlSetDetails.length > 0
                      ? (event) =>
                          filterSearchedItem(
                            "treeControlId",
                            event.target.value
                          )
                      : null
                  }
                  disabled={!controlSetDetails.length > 0}
                />
                <img
                  src={require("../../../Icons/Search.svg").default}
                  className={styles.searchIcon}
                  style={translationStyles}
                  alt="Search Icon"
                />
              </Col>

              <Col className={styles.controlCol}>
                {openCanvasForSubform === "advanceListviewFromScratch" &&
                advanceListviewStateJson !== undefined &&
                (controlSetJson && controlSetJson["RootControl"] && controlSetJson["RootControl"]["children"]) ? (
                  controlSetJson &&
                  prepareControlSet(
                    controlSetJson["RootControl"]["children"],
                    "form"
                  )
                ) : openCanvasForSubform === "advanceListviewFromScratch" &&
                  advanceListviewStateJson !== undefined ? (
                  prepareControlSet(controlSetJson, "form")
                ) : controlSetJson && controlSetJson["RootControl"] ? (
                  controlSetJson["RootControl"]["children"] &&
                  prepareControlSet(
                    controlSetJson["RootControl"]["children"],
                    "form"
                  )
                ) : (
                  <></>
                )}
              </Col>
            </Col>

            <Col className={styles.backdropRightBody}>
            <div className={styles.controlSetHeader}>
              <p className={styles.pageTitleText3}>
                {t("translation:Define Control Set")}
              </p>
              <span>
                {(isEditable || controlSetDetails.length <= 0) ? 
                <></>
                :
                <Button
                disableFocusRipple
                disableRipple
                tabIndex={0}
                  className={[
                    styles.editButton,
                    window?.psh_configs?.selectedLanguage === "ar" ||
                    window?.psh_configs?.selectedLanguage === "ar-SA"
                      ? styles.translationEditButton
                      : "",
                      "formBuilder-MuiButton-outlined"
                  ].join(" ")}
                  onClick={() => {
                    handleEdit();
                  }}
                >
                  {t("translation:Edit")}
                </Button>
                }
              </span>
            </div>
              <Col
                className={styles.controlSetNameWriteSearchCol}
                onClick={() => "All"}
              >
                <span
                  className={styles.pageTitleText2}
                  onClick={(ev) => handleControlSet(ev)}
                >
                  {t("translation:Control Set Name")}
                  <span style={{ color: "#D53D3D" }}>{"*"}</span>
                </span>
                <input
                  key={
                    controlSetDetails[selectedControlSetIndex] &&
                    selectedControlSetIndex +
                      controlSetDetails[selectedControlSetIndex].label
                  }
                  aria-label="Control Set Name"
                  type="text"
                  placeholder={t("translation:Control Set Name")}
                  className={styles.controlSetNameInput}
                  defaultValue={
                    controlSetDetails[selectedControlSetIndex] &&
                    controlSetDetails[selectedControlSetIndex].label
                  }
                  onBlur={(event) =>
                    handleControlSet(event, "changeLabel", event.target.value)
                  }
                  onChange={() => setModifyBtn(true)}
                  maxlength="200"
                  style={{
                    marginRight: matches ? "" : "5px",
                    width: matches ? "" : "180px",
                    marginLeft: matches ? "" : "10px",
                  }}
                  disabled={!isEditable}
                />

                <Col className={styles.searchCol + " " + styles.searchCol2}>
                  <input
                    type="text"
                    aria-label="Search Input"
                    placeholder={t("translation:Search")}
                    className={styles.searchInput}
                    onChange={
                      controlSetDetails.length > 0
                        ? (event) =>
                            filterSearchedItem("controlId", event.target.value)
                        : null
                    }
                  />
                  <img
                    src={require("../../../Icons/Search.svg").default}
                    className={styles.searchIcon}
                    style={translationStyles}
                    alt="Search Icon"
                  />
                </Col>
              </Col>

              <Col
                className={[
                  styles.controlsSetDefinitionDetails,
                  containerId === "mf_formBuilder"
                    ? classes.defnHeight
                    : classes.defnHeight2,
                ].join(" ")}
              >
                <Row className={styles.controlPropertyHeaderRow}>
                  <span className={styles.checkboxDiv}>
                    <input
                      type="checkbox"
                      aria-label="Check all"
                      onClick={(e) =>
                        handlecheckBoxChange(e, "allActionCheckboxClicked")
                      }
                      className={styles.controlNameCheckbox}
                      checked={
                        controlSetDetails?.[selectedControlSetIndex] && Object.keys(controlSetDetails?.[selectedControlSetIndex]).length > 1 && istrue()
                      }
                      disabled={!isEditable}
                    />
                  </span>

                  <Col
                    className={[
                      styles.controlNameCol,
                      styles.pageTitleText4,
                    ].join(" ")}
                  >
                    {t("translation:Control Name")}
                  </Col>

                  <Col
                    className={[styles.visibleCol, styles.pageTitleText4].join(
                      " "
                    )}
                  >
                    {t("translation:Visible")}
                  </Col>
                  <Col
                    className={[styles.enableCol, styles.pageTitleText4].join(
                      " "
                    )}
                  >
                    {t("translation:Enable")}
                  </Col>
                  <Col
                    className={[
                      styles.mandatoryCol,
                      styles.pageTitleText4,
                    ].join(" ")}
                  >
                    {t("translation:Mandatory")}
                  </Col>

                  <Col
                    className={[
                      matches
                        ? styles.defaultValueCol
                        : styles.defaultValueColIpad,
                      styles.pageTitleText4,
                    ].join(" ")}
                  >
                    {t("translation:Default Value")}
                  </Col>
                </Row>

                {filteredControlSetName &&
                filteredControlSetName["controlId"].length === 0
                  ? controlSetDetails &&
                    selectedControlSetIndex >= 0 &&
                    controlSetDetails[selectedControlSetIndex] &&
                    Object.keys(controlSetDetails[selectedControlSetIndex]).map(
                      (key, index) => {
                        return key !== "label" && key !== "extraDetails" ? (
                          <Row key={key} className={isEditable ? styles.controlPropertyRow : styles.controlPropertyRowDisabled}>
                            <span className={styles.checkboxDiv}>
                              <input
                                type="checkbox"
                                aria-label="Select Control"
                                onClick={(e) => handlecheckBoxChange(e, key)}
                                className={styles.controlNameCheckbox}
                                checked={
                                  controlSetDetails?.[
                                    selectedControlSetIndex
                                  ]?.[key]?.actionCheckboxChecked
                                }
                                disabled={!isEditable}
                              />
                            </span>

                            <Col
                              className={[
                                styles.controlNameCol,
                                styles.pageTitleText3,
                              ].join(" ")}
                            >
                              <span title={controlSetDetails[selectedControlSetIndex][key].label} className={styles.controlSetLabel}>
                                {
                                controlSetDetails[selectedControlSetIndex][key]
                                  .label
                                }
                              </span>
                            </Col>

                            <Col
                              className={window?.psh_configs?.selectedLanguage === "ar" || window?.psh_configs?.selectedLanguage === "ar-SA" ? [
                                styles.visibleColAr,
                                styles.pageTitleTextAr,
                                styles.ToggleBtn,
                              ].join(" ") : [
                                styles.visibleCol,
                                styles.pageTitleText,
                                styles.ToggleBtn,
                              ].join(" ") }
                            >
                              <ToggleBtn
                                externalStyling={{
                                  display: "flex",
                                  "align-items": "center",
                                  "margin-bottom": "0px",
                                }}
                                toggleState={
                                  controlSetDetails[selectedControlSetIndex][
                                    key
                                  ].value.charAt(0) === "1"
                                    ? "true"
                                    : "false"
                                }
                                
                                key={key + "_Visible_" + controlSetDetails[selectedControlSetIndex][key].value}

                                handleToggle={(ev, field) =>
                                  handleControlSet(ev, ev, field, key)
                                }
                                field={"Visible"}
                                disabled={!isEditable}
                                calledFromControlSet={true}
                              />
                            </Col>

                            <Col
                              className={window?.psh_configs?.selectedLanguage === "ar" || window?.psh_configs?.selectedLanguage === "ar-SA" ? [
                                styles.visibleColAr,
                                styles.pageTitleTextAr,
                                styles.ToggleBtn,
                              ].join(" ") : [
                                styles.visibleCol,
                                styles.pageTitleText,
                                styles.ToggleBtn,
                              ].join(" ") }
                            >
                              {controlSetDetails[selectedControlSetIndex][key].elem_type === "paragraph" ? 
                              null
                              :
                              <ToggleBtn
                                externalStyling={{
                                  display: "flex",
                                  "align-items": "center",
                                  "margin-bottom": "0px",
                                }}
                                toggleState={
                                  controlSetDetails[selectedControlSetIndex][
                                    key
                                  ].value.charAt(1) === "1"
                                    ? "true"
                                    : "false"
                                }
                                key={key + "_Enable_" + controlSetDetails[selectedControlSetIndex][key].value}
                                handleToggle={(ev, field) =>
                                  handleControlSet(ev, ev, field, key)
                                }
                                field={"Enable"}
                                disabled={!isEditable}
                                calledFromControlSet={true}
                              />
                              }
                            </Col>

                            <Col
                              className={window?.psh_configs?.selectedLanguage === "ar" || window?.psh_configs?.selectedLanguage === "ar-SA" ? [
                                styles.visibleColAr,
                                styles.pageTitleTextAr,
                                styles.ToggleBtn,
                              ].join(" ") : [
                                styles.visibleCol,
                                styles.pageTitleText,
                                styles.ToggleBtn,
                              ].join(" ") }
                            >
                              {controlSetDetails[selectedControlSetIndex][key].elem_type === "paragraph" ? 
                              null
                              :
                              <ToggleBtn
                                externalStyling={{
                                  display: "flex",
                                  "align-items": "center",
                                  "margin-bottom": "0px",
                                }}
                                toggleState={
                                  controlSetDetails[selectedControlSetIndex][
                                    key
                                  ].value.charAt(2) === "1"
                                    ? "true"
                                    : "false"
                                }
                                key={key + "_Mandatory_" + controlSetDetails[selectedControlSetIndex][key].value}
                                handleToggle={(ev, field) =>
                                  handleControlSet(ev, ev, field, key)
                                }
                                field={"Mandatory"}
                                disabled={!isEditable}
                                calledFromControlSet={true}
                              />
                              }
                            </Col>

                            <Col
                              className={[
                                styles.defaultValueCol,
                                styles.pageTitleText3,
                              ].join(" ")}
                            >
                              <div style={{display: 'flex'}}>
                              <div
                                className="dropdown_area"
                                style={{ marginLeft: controlSetDetails[selectedControlSetIndex][key]?.defaultValue === "Explicit" ? "-4%" : '-6%' }}
                              >
                                <select
                                  id={selectedControlSetIndex + key}
                                  name={"defaultValue"}
                                  className={styles.defaultValueDropdown}
                                  onChange={(ev) =>
                                    handleControlSet(
                                      ev,
                                      "combo",
                                      selectedControlSetIndex + key,
                                      key
                                    )
                                  }
                                  style={{ width: matches ? "" : "75px" }}
                                  disabled={!(controlSetDetails[selectedControlSetIndex][key].elem_type === "textarea" || 
                                    controlSetDetails[selectedControlSetIndex][key].elem_type === "textbox") || !isEditable}
                                >
                                  <option
                                    value="No Default"
                                    selected={
                                      controlSetDetails[
                                        selectedControlSetIndex
                                      ][key].defaultValue === "No Default"
                                        ? true
                                        : false
                                    }
                                  >
                                    {t("translation:No Default")}
                                  </option>
                                  <option
                                    value="Explicit"
                                    selected={
                                      controlSetDetails[
                                        selectedControlSetIndex
                                      ][key].defaultValue === "Explicit"
                                        ? true
                                        : false
                                    }
                                  >
                                    {t("translation:Explicit")}
                                  </option>
                                  <option
                                    value="Null/Empty"
                                    selected={
                                      controlSetDetails[
                                        selectedControlSetIndex
                                      ][key].defaultValue === "Null/Empty"
                                        ? true
                                        : false
                                    }
                                  >
                                    {t("translation:Null/Empty")}
                                  </option>
                                </select>
                              </div>

                              {controlSetDetails[selectedControlSetIndex][key]
                                .defaultValue === "Explicit" ? (
                                <div
                                  className="explicit_inputField"
                                  style={
                                    containerId === "mf_formBuilder"
                                      ? { marginLeft: "1%" }
                                      : {
                                          marginLeft: isSafariBrowser()
                                            ? "5%"
                                            : "1%",
                                          width: "38%",
                                        }
                                  }
                                  title={controlSetDetails[
                                    selectedControlSetIndex
                                  ][key].ExplicitValue}
                                >
                                  <input
                                    type="text"
                                    aria-label="Explicit value input"
                                    className={styles.explicitValueInputBox}
                                    key={
                                      controlSetDetails[
                                        selectedControlSetIndex
                                      ] &&
                                      selectedControlSetIndex +
                                        controlSetDetails[
                                          selectedControlSetIndex
                                        ][key].defaultValue
                                    }
                                    defaultValue={
                                      controlSetDetails[
                                        selectedControlSetIndex
                                      ][key].ExplicitValue
                                    }
                                    onBlur={(ev) =>
                                      handleControlSet(
                                        ev, 
                                        "explicitValue",
                                        ev.target.value,
                                        key
                                      )
                                    }
                                    style={{ width: "45px" }}
                                  />
                                </div>
                              ) : (
                                <></>
                              )}
                              </div>

                              <img
                                src={
                                  require("../../../Icons/deleteRed.svg")
                                    .default
                                }
                                className={styles.deleteIcon}
                                style={
                                  translationStyles1
                                    ? { left: 0, right: "unset" }
                                    : null
                                }
                                onClick={(ev) =>
                                  handleControlSet(
                                    ev,
                                    "actionDelete",
                                    "deleteSet",
                                    key
                                  )
                                }
                                alt="Delete Icon"
                              />
                            </Col>
                          </Row>
                        ) : null;
                      }
                    )
                  : controlSetDetails &&
                    selectedControlSetIndex >= 0 &&
                    controlSetDetails[selectedControlSetIndex] &&
                    Object.keys(controlSetDetails[selectedControlSetIndex]).map(
                      (key, index) => {
                        return key !== "label" &&
                          key !== "extraDetails" &&
                          controlSetDetails[selectedControlSetIndex][key]
                            .label &&
                          controlSetDetails[selectedControlSetIndex][key].label
                            .toLowerCase()
                            .includes(
                              filteredControlSetName[
                                "controlId"
                              ].toLocaleLowerCase()
                            ) ? (
                          <Row key={key} className={styles.controlPropertyRow}>
                            <span className={styles.checkboxDiv}>
                              <input
                                type="checkbox"
                                aria-label="Check Control"
                                onClick={(e) => handlecheckBoxChange(e, key)}
                                className={styles.controlNameCheckbox}
                                checked={
                                  controlSetDetails?.[
                                    selectedControlSetIndex
                                  ]?.[key]?.actionCheckboxChecked
                                }
                              />
                            </span>

                            <Col
                              className={[
                                styles.controlNameCol,
                                styles.pageTitleText3,
                              ].join(" ")}
                            >
                              {
                                controlSetDetails[selectedControlSetIndex][key]
                                  .label
                              }
                            </Col>
                            <Col
                              className={window?.psh_configs?.selectedLanguage === "ar" || window?.psh_configs?.selectedLanguage === "ar-SA" ? [
                                styles.visibleColAr,
                                styles.pageTitleTextAr,
                                styles.ToggleBtn,
                              ].join(" ") : [
                                styles.visibleCol,
                                styles.pageTitleText,
                                styles.ToggleBtn,
                              ].join(" ") }
                            >
                              <ToggleBtn
                                externalStyling={{
                                  display: "flex",
                                  "align-items": "center",
                                  "margin-bottom": "0px",
                                }}
                                toggleState={
                                  controlSetDetails[selectedControlSetIndex][
                                    key
                                  ].value.charAt(0) === "1"
                                    ? "true"
                                    : "false"
                                }
                                key={key + "_Visible_" + controlSetDetails[selectedControlSetIndex][key].value}
                                handleToggle={(ev, field) =>
                                  handleControlSet(ev, ev, field, key)
                                }
                                field={"Visible"}
                                calledFromControlSet={true}
                              />
                            </Col>

                            <Col
                              className={window?.psh_configs?.selectedLanguage === "ar" || window?.psh_configs?.selectedLanguage === "ar-SA" ? [
                                styles.visibleColAr,
                                styles.pageTitleTextAr,
                                styles.ToggleBtn,
                              ].join(" ") : [
                                styles.visibleCol,
                                styles.pageTitleText,
                                styles.ToggleBtn,
                              ].join(" ") }
                            >
                              <ToggleBtn
                                externalStyling={{
                                  display: "flex",
                                  "align-items": "center",
                                  "margin-bottom": "0px",
                                }}
                                toggleState={
                                  controlSetDetails[selectedControlSetIndex][
                                    key
                                  ].value.charAt(1) === "1"
                                    ? "true"
                                    : "false"
                                }
                                key={key + "_Enable_" + controlSetDetails[selectedControlSetIndex][key].value}
                                handleToggle={(ev, field) =>
                                  handleControlSet(ev, ev, field, key)
                                }
                                field={"Enable"}
                                calledFromControlSet={true}
                              />
                            </Col>

                            <Col
                              className={window?.psh_configs?.selectedLanguage === "ar" || window?.psh_configs?.selectedLanguage === "ar-SA" ? [
                                styles.visibleColAr,
                                styles.pageTitleTextAr,
                                styles.ToggleBtn,
                              ].join(" ") : [
                                styles.visibleCol,
                                styles.pageTitleText,
                                styles.ToggleBtn,
                              ].join(" ") }
                            >
                              <ToggleBtn
                                externalStyling={{
                                  display: "flex",
                                  "align-items": "center",
                                  "margin-bottom": "0px",
                                }}
                                toggleState={
                                  controlSetDetails[selectedControlSetIndex][
                                    key
                                  ].value.charAt(2) === "1"
                                    ? "true"
                                    : "false"
                                }
                                key={key + "_Mandatory_" + controlSetDetails[selectedControlSetIndex][key].value}
                                handleToggle={(ev, field) =>
                                  handleControlSet(ev, ev, field, key)
                                }
                                field={"Mandatory"}
                                calledFromControlSet={true}
                              />
                            </Col>

                            <Col
                              className={[
                                styles.defaultValueCol,
                                styles.pageTitleText3,
                              ].join(" ")}
                            >
                              <div style={{display: 'flex'}}>
                              <div
                                className="dropdown_area"
                                style={{ marginLeft: controlSetDetails[selectedControlSetIndex][key]?.defaultValue === "Explicit" ? "-4%" : '-6%' }}
                              >
                                <select
                                  id={selectedControlSetIndex + key}
                                  name={"defaultValue"}
                                  className={styles.defaultValueDropdown}
                                  onChange={(ev) =>
                                    handleControlSet(
                                      ev,
                                      "combo",
                                      selectedControlSetIndex + key,
                                      key
                                    )
                                  }
                                  style={{ width: matches ? "" : "75px" }}
                                  disabled={!(controlSetDetails[selectedControlSetIndex][key].elem_type === "textarea" || 
                                    controlSetDetails[selectedControlSetIndex][key].elem_type === "textbox") || !isEditable}
                                >
                                  <option
                                    value="No Default"
                                    selected={
                                      controlSetDetails[
                                        selectedControlSetIndex
                                      ][key].defaultValue === "No Default"
                                        ? true
                                        : false
                                    }
                                  >
                                    {"No Default"}
                                  </option>
                                  <option
                                    value="Explicit"
                                    selected={
                                      controlSetDetails[
                                        selectedControlSetIndex
                                      ][key].defaultValue === "Explicit"
                                        ? true
                                        : false
                                    }
                                  >
                                    {"Explicit"}
                                  </option>
                                  <option
                                    value="Null/Empty"
                                    selected={
                                      controlSetDetails[
                                        selectedControlSetIndex
                                      ][key].defaultValue === "Null/Empty"
                                        ? true
                                        : false
                                    }
                                  >
                                    {"Null/Empty"}
                                  </option>
                                </select>
                              </div>

                              {controlSetDetails[selectedControlSetIndex][key]
                                .defaultValue === "Explicit" ? (
                                <div
                                  title={controlSetDetails[selectedControlSetIndex][key].ExplicitValue}
                                  className="explicit_inputField"
                                  style={
                                    containerId === "mf_formBuilder"
                                      ? { marginLeft: "1%" }
                                      : {
                                          marginLeft: isSafariBrowser()
                                            ? "5%"
                                            : "1%",
                                          width: "38%",
                                        }
                                  }
                                >
                                  <input
                                    type="text"
                                    aria-label="Explicit Input Value"
                                    className={styles.explicitValueInputBox}
                                    defaultValue={
                                      controlSetDetails[
                                        selectedControlSetIndex
                                      ][key].ExplicitValue
                                    }
                                    onBlur={(ev) =>
                                      handleControlSet(
                                        ev,
                                        "explicitValue",
                                        ev.target.value,
                                        key
                                      )
                                    }
                                    style={{ width: "45px" }}
                                  />
                                </div>
                              ) : (
                                <></>
                              )}
                              </div>

                              <img
                                src={
                                  require("../../../Icons/deleteRed.svg")
                                    .default
                                }
                                className={styles.deleteIcon}
                                style={
                                  translationStyles1
                                    ? { left: 0, right: "unset" }
                                    : null
                                }
                                onClick={(ev) => handleControlSet(ev, "actionDelete", "deleteSet", key)}
                                alt="Delete Icon"
                              />
                            </Col>
                          </Row>
                        ) : null;
                      }
                    )}
              </Col>
            </Col>
          </Row>

          <Row className={styles.backdropFooter}>
            <Button
            disableFocusRipple
            disableRipple
            tabIndex={0} className={`${styles.cancelButton} formBuilder-MuiButton-outlined`}
              onClick={() => handleCancel()}
            >
              {t("translation:Cancel")}
            </Button>
            <Button
            disableFocusRipple
            disableRipple
            tabIndex={0}
              className={[
                styles.saveButton,
                window?.psh_configs?.selectedLanguage === "ar" ||
                window?.psh_configs?.selectedLanguage === "ar-SA"
                  ? styles.translationSaveButton
                  : "",
                  "formBuilder-MuiButton-outlined"
              ].join(" ")}
              onClick={() => {
                handleSave();
              }}
              disabled={!isChange}
            >
              {t("translation:Save")}
            </Button>
          </Row>
        </div>
      </Backdrop>
      {
        alertData.open === true &&
          <CustomizedAlert alertData={alertData}/>
      }
    </div>
  );

  function expandCollapse(controlSetJson, key) {
    setCheckDetails(!checkDetails);
    if (!checksIds.has(key)) {
      checksIds.add(key);
    } else {
      checksIds.delete(key);
    }
  }

  function prepareControlSet(controlSetJson, parent) {
    function clickOnDisable() {
      if (controlSetDetails.length > 0) {
        if (
          Object.keys(controlSetDetails[selectedControlSetIndex]).includes(
            parent
          ) === true
        ) {
          setAlertData({
            'open':true,
            "alertContentMsg": `${t("translation:Please remove the parent set first.")}`,
            'showConfirm':'showNotification',
            'alertType':'error',
            "autoHideDuration": 4000,
        })
        }
      } else {
        setAlertData({
          'open':true,
          "alertContentMsg": `${t("translation:No Control Sets found. Please create Control Sets before proceeding.")}`,
          'showConfirm':'showNotification',
          'alertType':'error',
          "autoHideDuration": 4000,
      })
      }
    }

    return Object.keys(controlSetJson).map((key) => {
      if (key.includes("TileGroup")) {
        controlSetJson[key].label = "tile group";
      }

      let check1 = false;
      //checking if children is present under frame then only show frame,other wise if children not present
      // in frame then dont show that frame

      if (filteredControlSetName["treeControlId"].length > 0)
        nestedSearching(key, controlSetJson);

      function nestedSearching(key, controlSetJson) {
        if (Object.hasOwn(controlSetJson[key], "children")) {
          for (const [key1, value1] of Object.entries(
            controlSetJson[key]?.children
          )) {
            let searchedText =
              filteredControlSetName["treeControlId"].toLocaleLowerCase();
            let currkey = controlSetJson[key]["children"][key1]?.label.toLowerCase();
            if (currkey.includes(searchedText)) {
              check1 = true;
            }

            if (
              Object.hasOwn(controlSetJson[key]["children"][key1], "children")
            )
              nestedSearching(key1, controlSetJson[key]["children"]);
          }
        }
      }

      return (
        <>
          {filteredControlSetName &&
          filteredControlSetName["treeControlId"].length === 0 ? (
            <>
              <Col
                className={[
                  styles.controlNameCollapsibleCol,
                  controlSetJson[key]?.children
                    ? null
                    : styles.noChildrenControl,
                ].join(" ")}
                id={controlSetJson.id + "ab"}
              >
                {controlSetJson[key]?.children && Object.keys(controlSetJson[key]?.children).length > 0 && checksIds.has(key) ? (
                  <>
                    <img
                      src={
                        require("../../../Icons/horizontalArrow.svg").default
                      }
                      style={{ cursor: "pointer" }}
                      className={styles.arrowIcon}
                      onClick={() => expandCollapse(controlSetJson, key)}
                      key={Math.random()}
                      index={controlSetJson.id}
                      alt="Horizontal Arrow Icon"
                    />
                  </>
                ) : controlSetJson[key]?.children && Object.keys(controlSetJson[key]?.children).length > 0 ? (
                  <>
                    <span
                      className={styles.arrowIcon}
                      onClick={() => expandCollapse(controlSetJson, key)}
                      key={Math.random()}
                      index={controlSetJson.id}
                    >
                      <DownArrow />
                    </span>
                  </>
                ) : (
                  <></>
                )}
                <div
                  className={styles.checkboxDiv}
                  onClick={() => clickOnDisable()}
                >
                  <input
                    type="checkbox"
                    aria-label="Check Control"
                    key={Math.random()}
                    index={controlSetJson.id}
                    className={styles.controlNameCheckbox}
                    defaultChecked={
                      controlSetJson[key]?.isChecked
                    }
                    disabled={
                      controlSetJson[key]?.isDisabled || !isEditable
                    }
                    onClick={(e) =>
                      handleControlSetDetails(
                        e,
                        "addDelete",
                        controlSetJson[key],
                        controlSetJson
                      )
                    }
                  />
                </div>

                <span title={controlSetJson[key]?.label} className={styles.controlSetLabel}>{controlSetJson[key]?.label}</span>
              </Col>

              {controlSetJson[key]?.children && !checksIds.has(key) && (
                <Row className={styles.controlNameRowBody}>
                  <Col className={styles.controlNameColInnerBody}>
                    {controlSetJson[key]?.children &&
                      prepareControlSet(controlSetJson[key]?.children, key)}
                  </Col>
                </Row>
              )}
            </>
          ) : (
            <>
              {((controlSetJson[key]?.label &&
                controlSetJson[key]?.label
                  .toLowerCase()
                  .includes(
                    filteredControlSetName["treeControlId"].toLocaleLowerCase()
                  )) ||
                check1) && (
                <>
                  <Col
                    className={[
                      styles.controlNameCollapsibleCol,
                      controlSetJson[key]?.children
                        ? null
                        : styles.noChildrenControl,
                    ].join(" ")}
                    id={controlSetJson.id + "ab"}
                  >
                    {controlSetJson[key]?.children && Object.keys(controlSetJson[key]?.children).length > 0 && checksIds.has(key) ? (
                      <>
                        <img
                          src={
                            require("../../../Icons/horizontalArrow.svg")
                              .default
                          }
                          style={{ cursor: "pointer" }}
                          className={styles.arrowIcon}
                          onClick={() => expandCollapse(controlSetJson, key)}
                          key={Math.random()}
                          index={controlSetJson.id}
                          alt="Horizontal Arrow Icon"
                        />
                      </>
                    ) : controlSetJson[key]?.children && Object.keys(controlSetJson[key]?.children).length > 0 ? (
                      <>
                        <span
                          className={styles.arrowIcon}
                          onClick={() => expandCollapse(controlSetJson, key)}
                          key={Math.random()}
                          index={controlSetJson.id}
                        >
                          <DownArrow />
                        </span>
                      </>
                    ) : (
                      <></>
                    )}

                    <div
                      className={styles.checkboxDiv}
                      onClick={() => clickOnDisable()}
                    >
                      <input
                        type="checkbox"
                        aria-label="Check Control1"
                        key={Math.random()}
                        index={controlSetJson.id}
                        className={styles.controlNameCheckbox}
                        defaultChecked={
                          controlSetDetails[selectedControlSetIndex] &&
                          Object.keys(
                            controlSetDetails[selectedControlSetIndex]
                          ).includes(key) === true
                            ? true
                            : false
                        }
                        onClick={(e) =>
                          handleControlSetDetails(
                            e,
                            "addDelete",
                            controlSetJson[key],
                            controlSetJson
                          )
                        }
                        disabled={
                          controlSetDetails[selectedControlSetIndex] &&
                          Object.keys(
                            controlSetDetails[selectedControlSetIndex]
                          ).includes(parent) === true
                            ? true : !isEditable ? true
                            : false
                        }
                      />
                    </div>
                    <span title={controlSetJson[key]?.label} className={styles.controlSetLabel}>{controlSetJson[key]?.label}</span>
                  </Col>

                  {controlSetJson[key]?.children && !checksIds.has(key) && (
                    <Row className={styles.controlNameRowBody}>
                      <Col className={styles.controlNameColInnerBody}>
                        {controlSetJson[key]?.children &&
                          prepareControlSet(controlSetJson[key]?.children, key)}
                      </Col>
                    </Row>
                  )}
                </>
              )}
            </>
          )}
        </>
      );
    });
  }
  function readFormData(jsonData, controlSetJson, controlSetJson1, allFormIds) {
    if (Array.isArray(jsonData)) {
      for (let index = 0; index < jsonData.length; index++) {
        let item = jsonData[index];
        const ParentofItem = item["elem_type"] === "sheet" ? findParent(
          (
            openCanvasForSubform === "advanceListviewFromScratch" &&
            advanceListviewStateJson !== undefined
          ) 
          ? advanceListviewStateJson:
          (
            openCanvasForSubform === "subform" &&
            subFormStateJson !== undefined
          ) 
          ? subFormStateJson : 
           formState2, item?.id) : undefined;
        var component = {};
        if (
          item["elem_type"] &&
          item["elem_type"] !== "row" &&
          item["elem_type"] !== "column" &&
          !allFormIds.has(item.id)
        ) {
          allFormIds.add(item.id);
          controlSetJson[item.id] = {
            id: item.id,
            label: item?.style?.Label
              ? item.style.Label 
              : item.dataclass
              ? item.dataclass
              : item?.tabChildName 
              ? item?.tabChildName 
              : item?.stepName
              ? item?.stepName
              : item.id,
            elem_type: item["elem_type"],
            checked: "n",
            isChecked: false,
            isDisabled: false,
            actionCheckboxChecked: false,
            value: item["elem_type"] === "paragraph" ? "100" : "110",
            tabId: ParentofItem,
          };
          controlSetJson1[item.id] = false;

          if (item["children"]) {
            controlSetJson[item.id]["children"] = {};
          }
          if (Object.keys(item).includes("children")) {
            readFormData(
              item["children"],
              controlSetJson[item.id]["children"],
              controlSetJson1,
              allFormIds
            );
          }
        }
        if (Object.keys(item).includes("children")) {
          readFormData(
            item["children"],
            controlSetJson,
            controlSetJson1,
            allFormIds
          );
        }
      }
    } else {
      if (
        jsonData?.elem_type &&
        jsonData["elem_type"] !== "row" &&
        jsonData["elem_type"] !== "column"
      ) {
        controlSetJson[jsonData.id] = {
          id: jsonData.id,
          label: jsonData.controlName ? jsonData.controlName : jsonData.id,
          elem_type: jsonData["elem_type"],
          checked: "n",
          isChecked: false,
          isDisabled: false,
          actionCheckboxChecked: false,
          value: "000",
        };
        controlSetJson1[jsonData.id] = false;
        if (Object.keys(jsonData)?.includes("children")) {
          controlSetJson[jsonData.id]["children"] = {};
        }
        if (Object.keys(jsonData)?.includes("children")) {
          readFormData(
            jsonData["children"],
            controlSetJson[jsonData.id]["children"],
            controlSetJson1
          );
          return;
        }
      }
      if (jsonData && Object.keys(jsonData)?.includes("children")) {
        readFormData(jsonData["children"], controlSetJson, controlSetJson1);
      }
    }
    
    setControlSetJson({...controlSetJson});
  }

  function updateData (dataJson, controlSet) {
    if(dataJson["id"] === controlSet?.id){
      controlSet["label"] = dataJson["label"]
      return {...controlSet}
    }

    if(Object.keys(dataJson).includes("children") && Object.keys(dataJson["children"]).length > 0){
      Object.keys(dataJson["children"]).forEach((key) => {
        let item = dataJson["children"][key]
        updateData(item, controlSet)
      })
    }
    return {...controlSet}
  }
  
}


const makeAllChildDisable = (childData, isParentChecked) => {
  if(isParentChecked){
    childData.isDisabled = true
  }else{
    childData.isDisabled = false
  }
  if(Object.keys(childData).includes("children") && Object.keys(childData["children"]).length > 0){
    Object.keys(childData["children"]).forEach((key) => {
      let item = childData["children"][key]
      makeAllChildDisable(item, childData["isDisabled"])
    })
  }
  return {...childData}
}

const makeAllCheck = (data) => {
  data.isChecked = !data?.isChecked

  if(Object.keys(data).includes("children") && Object.keys(data["children"]).length > 0){
    Object.keys(data["children"]).forEach((key) => {
      let item = data["children"][key]
      let checked = makeAllChildDisable(item, data["isChecked"])
      return {...checked}
    })
  }

  return {...data}
}

const handleCheckData = (data, id) => {
    if(data?.id === id){
      let res = makeAllCheck(data)
      return {...res}
    }

    if(Object.keys(data).includes("children") && Object.keys(data["children"]).length > 0){
      Object.keys(data["children"]).forEach((keys) => {
        let item = data["children"][keys]
        handleCheckData(item, id)
      })
    }
  return {...data}
}

const handleUncheckAll = (data) => {
  data.isChecked = false
  data.isDisabled = false

  if(Object.keys(data).includes("children") && Object.keys(data["children"]).length > 0){
    Object.keys(data["children"]).forEach((keys) => {
      let item = data["children"][keys]
      handleUncheckAll(item)
    })
  }
  return {...data}
}

const checkedChild = (data, arr) => {
  if(data.isChecked){
    arr.push(true)
  }

  if(Object.keys(data).includes("children") && Object.keys(data["children"]).length > 0){
    Object.keys(data["children"]).forEach((keys) => {
      checkedChild(data["children"][keys], arr)
    })
  }

  return arr
}

const IsChildChecked = (data) => {
  let arr = []
  let res;

  if(Object.keys(data).includes("children") && Object.keys(data["children"]).length > 0){
    Object.keys(data["children"]).forEach((keys) => {
      res = checkedChild(data["children"][keys], arr)
    })
  }

  return arr.length > 0 ? true : false
}

const findParent = (obj, targetId, parent = null) => {
  if (obj?.id === targetId) {
    return parent?.id;
  }
  if (obj?.children) {
    for (let child of obj?.children) {
      const result = findParent(child, targetId, obj);
      if (result) {
        return result;
      }
    }
  }
  return null;
}